import me from "../static/images/me.jpg";
import { HomeIcons, HomeText } from "../components/Home/Home.js";
import ContentCard from "../components/ContentCard/ContentCard.js";

export default function HomePage() {
  return (
    <div className="Home">
      <img src={me} id="title-picture" alt="Me in Tuscany, Italy" />
      <div className="Home-title">
        <h1>Zachary Foteff</h1>
        <h2>Software Engineer</h2>
        <h2>Vancouver, WA</h2>
      </div>
      <ContentCard>
        <HomeIcons />
        <HomeText />
      </ContentCard>
    </div>
  );
}
